// import { A_PROPERTY_TYPES_FOR_PROJECT } from "@/shared/models/const/properties/real-estate-type.const";
import {
  A_CURRENCY,
  C_CURRENCY
} from "@/src-refactor/modules/shared/model/const/currency.conts";
import { A_ARRANGEMENTS_TYPE } from "@/src-refactor/modules/shared/model/const/property/arrangement-type.const";
import { A_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import { A_PROPERTY_TYPES_FOR_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import HCheckArray from "@rf-helper/check-have-value";
import { AYesAndNo } from "@rf/const/yes-and-no.const";

export const GetArrangementsType = (value: string | number) =>
  A_ARRANGEMENTS_TYPE.filter(x => x.id == value);

export const GetProjectType = (value: string | number) =>
  A_PROPERTY_TYPES_FOR_PROJECT.filter(x => x.id == value);

export const GetConditionStatus = (value: string | number) =>
  A_CONDICTION_PROPERTY.filter(x => x.name == value);

export const GetCurrencyType = (value: string | number) => {
  const result = A_CURRENCY.filter(x => x.id === value);
  return result.length > 0 ? result : [C_CURRENCY.RD];
};

export const GetYesAndNotType = (value: string | number) => {
  const state = A_YES_AND_NOT.filter(x => x.id == value);
  return HCheckArray(state) ? state : [AYesAndNo[1]];
};
